module.exports = __webpack_public_path__ + "img/mobile.9bf1b604.png";